import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinambititpark() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Ambattur Ambit IT Park',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Ambattur Ambit IT Park',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Ambattur Ambit IT Park, catering to the transportation needs of IT companies, corporate offices, and business centers in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Ambattur Ambit IT Park.',

    top: 'Top Places to Visit in Ambattur Ambit IT Park with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Ambit IT Park, Ambattur",
    "description": "Ambit IT Park is a prominent technology hub located in Ambattur, Chennai. It hosts numerous IT and software companies in state-of-the-art office spaces with modern infrastructure, conference rooms, and landscaped surroundings. The park fosters innovation and collaboration, making it a key destination for IT professionals, corporate clients, and startups in the region."
  },
  {
    "title": "Nearby Cafés and Restaurants",
    "description": "The area around Ambit IT Park features a variety of cafés, restaurants, and casual dining options catering to office employees and visitors. From South Indian delicacies to international cuisines, these eateries provide convenient lunch options, business meeting venues, and relaxing spots after work hours."
  },
  {
    "title": "Ambattur Industrial Estate",
    "description": "Located close to Ambit IT Park, Ambattur Industrial Estate is a hub for manufacturing, small-scale industries, and corporate offices. It offers insight into Chennai’s industrial development and serves as a complement to the IT-driven economy in Ambattur, providing employment and business opportunities in the vicinity."
  },
  {
    "title": "Parks and Green Spaces",
    "description": "Surrounding Ambit IT Park are landscaped gardens and small green spaces that provide employees and visitors with a refreshing environment. These areas are ideal for short breaks, walking, outdoor meetings, and relaxation amidst the bustling IT campus."
  },
  {
    "title": "Hotels and Business Accommodations",
    "description": "Nearby hotels and serviced apartments offer convenient lodging options for visiting professionals, clients, and corporate guests. These accommodations feature modern amenities and easy access to Ambit IT Park, supporting business travel and corporate stays."
  },
  {
    "title": "Transport Connectivity",
    "description": "Ambit IT Park enjoys excellent connectivity via Chennai’s arterial roads, nearby railway stations, and public transport systems. The easy access ensures smooth commuting for employees and clients, making it an accessible IT hub in the western suburbs of Chennai."
  },
  {
    "title": "Fitness and Wellness Centers",
    "description": "The vicinity of Ambit IT Park includes gyms, yoga studios, and wellness centers catering to IT professionals. These facilities promote fitness, wellness programs, and stress relief, providing a healthy work-life balance for employees."
  },
  {
    "title": "Nearby Educational Institutions",
    "description": "The Ambattur area houses several schools, colleges, and training institutes, offering educational opportunities for employees’ families and local residents. These institutions contribute to the community development and add value to the locality surrounding Ambit IT Park."
  },
  {
    "title": "Shopping and Convenience Stores",
    "description": "Nearby shopping centers, supermarkets, and convenience stores provide easy access to essential goods, groceries, and retail items for IT park employees and local residents. The convenience enhances daily life and adds to the overall infrastructure of the area."
  },
  {
    "title": "Networking and Professional Events",
    "description": "Ambit IT Park hosts occasional professional meetups, tech seminars, workshops, and corporate events. These gatherings provide opportunities for skill development, networking, knowledge exchange, and collaboration among IT professionals, enhancing the innovation ecosystem in the park."
  }
],


"services": [
{
"name": "Ambit IT Park Shuttle",
"description": "Ambit IT Park Shuttle provides a fully managed, high-capacity corporate shuttle system designed for employees commuting to Ambit IT Park. The service includes AC minibuses, route clustering, real-time GPS visibility, shift-based scheduling, trip monitoring, and centralized command support. Built for IT and corporate zones with dense workforce movement, it ensures smooth, timely, and safe staff transfers during peak and non-peak hours, offering dependable mobility for companies of all sizes operating within Ambattur’s Ambit IT corridor."
},
{
"name": "Ambattur Ambit Corporate Cab",
"description": "Ambattur Ambit Corporate Cab delivers premium-quality corporate cab solutions tailored for businesses operating around Ambit IT Park. With a fleet of sedans, SUVs, and shuttles driven by experienced chauffeurs, the service provides punctual pickups, route optimization, multi-shift operations, and GPS-enabled tracking. It is ideal for daily employee commuting, executive travel, client visits, and inter-office movement, ensuring a dependable and professionally managed mobility experience for corporate clients."
},
{
"name": "Employee Commute Ambit IT Park",
"description": "Employee Commute Ambit IT Park offers structured daily pickup–drop transport designed for IT employees working in Ambit Tech Park. It features fixed and flexible routes, shift-aligned scheduling, real-time trip updates, professional drivers, and end-to-end transport supervision. The service helps companies maintain punctuality, reduce commute stress for employees, and streamline workforce mobility with high safety and operational consistency."
},
{
"name": "Business Cab Ambit",
"description": "Business Cab Ambit provides executive-level travel for client meetings, airport transfers, on-demand intra-city trips, and corporate visits. This service includes modern sedans and SUVs equipped with comfort features and operated by trained chauffeurs familiar with corporate protocols. With priority dispatching, clean vehicles, and guaranteed punctuality, it delivers a smooth, professional, and comfortable mobility experience for business travelers operating in and around Ambit IT Park."
},
{
"name": "Monthly Corporate Cab Ambit",
"description": "Monthly Corporate Cab Ambit offers contract-based staff transportation with dedicated cabs, skilled drivers, full maintenance support, GPS monitoring, and 24/7 operational coordination. Designed for companies that require consistent, uninterrupted mobility, it ensures predictable costs, reliable schedules, flexible routing, and efficient transport plans tailored to workforce size and shift patterns within Ambit IT Park."
},
{
"name": "Best Cab Ambit IT Park",
"description": "Best Cab Ambit IT Park delivers top-tier corporate cab services with high-quality vehicles, verified chauffeurs, strict compliance standards, and an enhanced travel experience. Ideal for executives, VIPs, and key managerial staff, it offers luxury interiors, assured punctuality, professional service, and seamless coordination for business meetings, airport transfers, and daily office commuting across the Ambit IT Park region."
},
{
"name": "Affordable Cab Ambit",
"description": "Affordable Cab Ambit provides cost-effective transportation without compromising safety, punctuality, or reliability. Tailored for startups, SMEs, and mid-sized corporates in the Ambit IT area, the service features optimized routing, economical long-term packages, trained drivers, clean vehicles, and transparent pricing, making everyday staff commute both budget-friendly and well-organized."
},
{
"name": "Staff Pickup Drop Ambit",
"description": "Staff Pickup Drop Ambit offers streamlined and highly coordinated pickup–drop transportation for employees working across Ambattur and Ambit IT Park. It includes pre-mapped routes, route optimization technology, punctual driver operations, attendance integration, and 24/7 monitoring. Designed for multi-shift environments, it ensures employees reach their workplace safely, consistently, and on time with minimal operational complexity for employers."
},
{
"name": "Outstation Cab Ambit",
"description": "Outstation Cab Ambit provides long-distance travel services for business trips, client meetings, factory visits, and intercity road travel. Featuring well-maintained sedans and SUVs, trained chauffeurs, interstate documentation, and real-time tracking, the service ensures safe, comfortable, and professionally coordinated mobility for organizations requiring reliable outstation travel from Ambit IT Park."
},
{
"name": "Sedan Cab Ambit",
"description": "Sedan Cab Ambit offers executive-level sedans for daily office commute, airport transfers, business meetings, and premium corporate mobility needs. Each sedan is equipped with comfortable seating, premium interiors, advanced safety features, and operated by professional chauffeurs trained to adhere to corporate hospitality standards."
},
{
"name": "SUV Cab Ambit",
"description": "SUV Cab Ambit provides spacious, high-comfort SUVs ideal for senior executives, team travel, outstation trips, and long-distance corporate drives. With ample legroom, superior ride quality, safety features, and skilled chauffeurs, the service ensures a premium mobility experience for clients requiring comfort and reliability."
},
{
"name": "Office Transport Ambit",
"description": "Office Transport Ambit delivers organized, shift-based office commute operations for employees working in and around Ambit IT Park. It features GPS-enabled vehicles, trained drivers, adherence to safety protocols, centralized coordination, and customizable route planning to ensure everyday office travel is reliable, safe, and punctual."
},
{
"name": "Corporate Fleet Ambit IT Park",
"description": "Corporate Fleet Ambit IT Park offers end-to-end corporate mobility outsourcing, including sedans, SUVs, employee shuttles, and management services. With vehicle maintenance, driver supervision, compliance tracking, GPS monitoring, and scalable fleet deployment, it supports companies in maintaining efficient, cost-effective, and professional transport operations within Ambit IT Park."
},
{
"name": "Factory Transport Ambit",
"description": "Factory Transport Ambit provides dedicated workforce mobility solutions for industrial units around Ambattur and Ambit IT Park. It includes shift-based routing, workforce scheduling, large-capacity vehicles, trained drivers, and real-time trip monitoring, ensuring safe, timely, and efficient transport for factory workers across multiple shifts."
},
{
"name": "Employee Shuttle Ambit",
"description": "Employee Shuttle Ambit offers coordinated shuttle services for medium and large organizations requiring bulk employee movement. With AC minibuses, optimized routing, dependable drivers, real-time updates, and strict safety protocols, it ensures smooth, organized, and dependable shuttle operations for employees traveling to and from Ambit IT Park."
}
],

"tableData": [
["Ambit IT Park Shuttle", "Ambattur Ambit Corporate Cab"],
["Employee Commute Ambit IT Park", "Business Cab Ambit"],
["Monthly Corporate Cab Ambit", "Best Cab Ambit IT Park"],
["Affordable Cab Ambit", "Staff Pickup Drop Ambit"],
["Outstation Cab Ambit", "Sedan Cab Ambit"],
["SUV Cab Ambit", "Office Transport Ambit"],
["Corporate Fleet Ambit IT Park", "Factory Transport Ambit"],
["Employee Shuttle Ambit", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Ambattur Ambit IT Park",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Ambattur Ambit IT Park, ensuring smooth and efficient daily commuting for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We provide punctual pickups and drop-offs across Ambit IT Park and surrounding industrial and commercial hubs, helping professionals reach their destinations on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled and courteous drivers ensure safe, disciplined, and comfortable travel for all corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from a wide range of sedans, SUVs, tempo travellers, and buses—each regularly sanitized, serviced, and maintained for dependable corporate transportation."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored travel plans that meet the specific commuting needs of employees and companies operating in Ambattur Ambit IT Park."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Assistance",
    "WhyChoosedescription": "Our team is available round-the-clock to handle bookings, emergency travel needs, and route adjustments, ensuring smooth and uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All our vehicles are sanitized regularly and equipped with modern safety features, offering secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "We simplify corporate transportation with our streamlined booking system and efficient coordination, making employee commute management hassle-free."
  }
]






































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Ambattur Ambit IT Park?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies located in Ambattur Ambit IT Park, Chennai.',
  },
  {
    question: 'What types of transportation services do you offer in Ambattur Ambit IT Park?',
    answer: 'We provide employee transportation, corporate pickups and drops, shuttle services, airport transfers, and complete fleet management solutions.',
  },
  {
    question: 'Do you support daily employee commute services for Ambattur Ambit IT Park companies?',
    answer: 'Yes, we offer optimized daily commute services with punctual pickups, efficient routing, and multi-shift coverage for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Ambattur Ambit IT Park?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Ambattur?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, electric cabs, luxury cars, and tempo travellers based on requirements.',
  },
  {
    question: 'Do you provide long-term contract-based corporate cab services?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with flexible and transparent pricing.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'Yes, all vehicles come with GPS tracking, emergency support, hygiene protocols, and well-trained verified chauffeurs.',
  },
  {
    question: 'Do you support night shift and rotational shift cab services for Ambattur Ambit IT Park?',
    answer: 'Absolutely. We offer safe and timely transportation for night shifts, early morning shifts, and rotational employee schedules.',
  },
  {
    question: 'What payment options do you offer for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also provide corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Ramanathan',
    feedback: 'A very professional corporate cab service for our Ambit IT Park office. Timely service and courteous drivers make commuting smooth.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Lakshmi Duraisamy',
    feedback: 'Reliable and efficient transportation partner. Our employees appreciate their punctuality and clean vehicles.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Ambattur Ambit IT Park",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-ambit-it-park.jpg", // replace with real image URL
  "description":
    "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Ambattur Ambit IT Park, including employee commute, corporate shuttles, business cabs, staff pickup & drop, monthly cab services, outstation corporate travel, sedan and SUV cabs, and complete corporate fleet management for companies operating in Ambit IT Park.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-ambit-it-park-ambattur"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Ambattur Ambit IT Park | Employee & Business Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services in Ambattur Ambit IT Park including employee commute, corporate shuttle, staff pickup & drop, business cabs, monthly cabs, outstation travel, and full corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Ambit IT Park Shuttle, Ambattur Ambit Corporate Cab, Employee Commute Ambit IT Park, Business Cab Ambit, Monthly Corporate Cab Ambit, Best Cab Ambit IT Park, Affordable Cab Ambit, Staff Pickup Drop Ambit, Outstation Cab Ambit, Sedan Cab Ambit, SUV Cab Ambit, Office Transport Ambit, Corporate Fleet Ambit IT Park, Factory Transport Ambit, Employee Shuttle Ambit"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinambititpark;